module.exports = __webpack_public_path__ + "static/the-second-world-war-ff8281eccb40e81b1e8712d9863bd22d.jpg";